import React, { useEffect, useState } from "react";
import CreateFeedTutor from "./CreateFeedTutor";
import MultipleUploadTutorFeed from "./MultipleUploadTutorFeed.js";
import { getTutorsFeed } from "../../../actions/tutorFeedActions";
import StudentMultipleUploadFeed from "../../website/feedTypes/feedComponents/StudentMultipleUploadFeed.js";

const TutorFeeds = () => {
  const [teacherId, setteacherId] = useState(null);
  const [feedsData, setfeedsData] = useState([]);
  const [limit, setlimit] = useState(10);
  const [isLoading, setisLoading] = useState(false);
  useEffect(() => {
    setisLoading(true);
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    if (tutorData != null) {
      setteacherId(tutorData.user.id);
    }
    getTutorsFeed(tutorData.user.id, limit).then((res) => {
      setfeedsData(res?.data);
      setisLoading(false);
      debugger;
    });
  }, [limit]);

  const tutorsFeedFunc = () => {
    getTutorsFeed(teacherId, limit).then((res) => {
      debugger;
    });
  };

  console.log("feedsData", feedsData);
  return (
    <div className="row">
      <div className="col-md-7">
        <CreateFeedTutor />
        {feedsData?.map((item) =>
          item?.feed_label === "teacher_upload_multiple" || item?.feed_label === "teacher_message_text" ? (
            <MultipleUploadTutorFeed item={item} feed_data={item?.feed_data} />
          ) : item?.feed_label === "student_upload_multiple" ? (
            <StudentMultipleUploadFeed item={item} feed_data={item?.feed_data} />
          ) : null
        )}
        <div className="text-center">
          <button
            className="btn btn-warning btn-sm mb-5"
            onClick={() => setlimit(limit + 10)}
          >
            Load More
            {isLoading ? (
              <div
                className="spinner-border spinner-border-sm ml-2"
                role="status"
              >
                <span className="sr-only mt-2">Loading...</span>
              </div>
            ) : (
              <i className="fa fa-chevron-down ml-2"></i>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TutorFeeds;
